import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import SendingModalWrapper from '../sendingModalWrapper/SendingModalWrapper';
import {TState} from '../../../../redux/store.type';
import {TabType} from '../../types';
import * as css from '../sendingModalWrapper/SendingModalWrapper.css';
import {getStaticImage} from '../../../../globalVariables/GlobalVariables';
import {mailingBank} from '../../icons/images';
import {TShow} from '../../../prompotionPopup/PromotionPopup';
import setGlobalState from '../../../../redux/setGlobalState';

function UpgradeModal({show, currentTab}: {show: TShow; currentTab: TabType;}) {
    const {t} = useTranslation('mailing');
    const billPackage = useSelector((state: TState) => state.account.billPackage);
    const amountLeftSMS = billPackage?.smsFreeAmount || 0;
    const amountLeftEmail = billPackage?.emailFreeAmount || 0;
    const amountLeft = currentTab === 'sms' ? amountLeftSMS : amountLeftEmail;
    const image = getStaticImage(mailingBank);

    const onSendWithoutUpgrade = () => {
        show.close();
        setGlobalState('ui.show.isOpenSendApproval', true);
    };
    const onUpgrade = () => {
        show.close();
        setGlobalState('ui.show.isOpenPackageSelection', true);
    };
    const buttons = {
        whiteBtn: {
            text: t('sendWithoutUpgrade'),
            onClick: onSendWithoutUpgrade
        },
        blueBtn: {
            text: t('upgradeNow'),
            onClick: onUpgrade
        }
    };

    return (
        <css.upgradeModalContainer>
            <SendingModalWrapper
                show={show}
                title={t('mailingBank')}
                buttons={buttons}
                dataCy="upgradeModal"
                headerImage={image}
                headerHeight="tall"
            >
                <css.warningIcon>
                    <css.exclamationMark>!</css.exclamationMark>
                </css.warningIcon>
                <css.messageText>
                    <css.messageLine>{t(`${currentTab}Left`, {count: amountLeft})}</css.messageLine>
                    <css.messageLine>{t('upgradeEasily')}</css.messageLine>
                    <css.messageLine>{t('unbeatablePrices')}</css.messageLine>
                </css.messageText>
            </SendingModalWrapper>
        </css.upgradeModalContainer>
    );
}

export default UpgradeModal;
